import React from 'react';
import PropTypes from 'prop-types';

function WarningTriangleIcon({ className = '', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      {...props}
    >
      <path d='M12 9v4' />
      <path d='M12 17h.01' />
      <path d='M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z' />
    </svg>
  );
}

WarningTriangleIcon.propTypes = {
  className: PropTypes.string,
};

export default WarningTriangleIcon;
